var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('header-bar'),_vm._v(" "),(_vm.$route.path === '/')?_c('navbar',{attrs:{"show":true}}):_c('navbar-admin',{attrs:{"show":true}}),_vm._v(" "),_c('app-main'),_vm._v(" "),_c('footer-bar')],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8ae0d7ee","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/App.vue
// module id = U//Q
// module chunks = 3 4